import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31f3c64e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "passwordLogin" }
const _hoisted_2 = { style: {"margin-bottom":"34px"} }
const _hoisted_3 = { style: {"margin-bottom":"34px"} }
const _hoisted_4 = { class: "Fpass" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_field, {
        modelValue: $setup.username,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.username) = $event)),
        modelModifiers: { trim: true },
        class: "inputBox",
        center: "",
        clearable: "",
        autofocus: "",
        "left-icon": "contact",
        placeholder: "Username/Email/Phone No."
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_field, {
        modelValue: $setup.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
        modelModifiers: { trim: true },
        class: "inputBox",
        type: $setup.isShowPassword ? 'text' : 'password',
        "right-icon": $setup.isShowPassword ? 'eye':'closed-eye',
        center: "",
        clearable: "",
        onClickRightIcon: $setup.isShowPWFn,
        "left-icon": 'https://image.kilimall.com/kenya/wap/icons/password.png'.webpFilters()
,
        placeholder: "Enter Password"
      }, null, 8, ["modelValue", "type", "right-icon", "onClickRightIcon", "left-icon"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.goFPassword && $setup.goFPassword(...args)))
        }, "Forgot Password?")
      ])
    ])
  ]))
}